import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  Typography,
} from '@mui/material';
import { SearchBarSuggestionsProps } from 'src/components/SearchBar/SearchBarSuggestions/SearchBarSuggestions.types';

const SearchBarSuggestions: React.FC<SearchBarSuggestionsProps> = ({
  suggestions,
  searchTerm,
  onSuggestionClick,
}) => {
  const highlightMatch = (text: string, query: string) => {
    if (!query) return text;

    const parts = text.split(new RegExp(`(${query})`, 'gi'));
    return (
      <>
        {parts.map((part, index) =>
          part.toLowerCase() === query.toLowerCase() ? (
            <Typography
              key={index}
              component="span"
              fontWeight="fontWeightBold"
            >
              {part}
            </Typography>
          ) : (
            <Typography key={index} component="span">
              {part}
            </Typography>
          )
        )}
      </>
    );
  };

  return (
    <List>
      {suggestions.map((suggestion, index) => (
        <div key={index}>
          <ListItem disablePadding>
            <ListItemButton onClick={() => onSuggestionClick(suggestion)}>
              {highlightMatch(suggestion, searchTerm)}
            </ListItemButton>
          </ListItem>
          {index < suggestions.length - 1 && <Divider />}
        </div>
      ))}
    </List>
  );
};

export default SearchBarSuggestions;
